import { SxProps } from '@mui/material';
import { blue, grey10, grey4, grey9, red2 } from 'app/components/ThemeProvider/colors';
import { CSSProperties } from 'react';

export const uploadBox: SxProps = {
  background: grey10,
  border: '1px dashed rgba(20, 25, 31, 0.16)',
  width: '720px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  fontWeight: '400',
  p: '40px 0',
  mb: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  zIndex: 0,

  '&:hover': {
    cursor: 'pointer',
    borderColor: blue,
    background: grey9,
  },

  '& .MuiSvgIcon-root': {
    width: '32px',
    height: '32px',
  },

  '@media screen and (max-width: 1155px)': {
    width: '100%',
  },
};

export const inputProps: CSSProperties = {
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: ' 1px',
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: '1px',
};

export const fileDetailsInfo: SxProps = {
  fontSize: '13px',
  fontWeight: '400',
  color: 'rgba(20, 25, 31, 0.56)',
};

export const fileDetailsInfoSize = (flag: boolean) => {
  return {
    fontSize: '13px',
    fontWeight: '400',
    color: flag ? red2 : 'rgba(20, 25, 31, 0.56)',
  };
};

export const fileDetailsSpanInfo: SxProps = {
  fontSize: '13px',
  fontWeight: '400',
  color: 'rgb(20, 25, 31)',
};

export const fileDetailsBox: SxProps = { display: 'flex', flexDirection: 'column', gap: '8px' };

export const header: SxProps = { fontSize: '15px', fontWeight: 400, mb: '16px' };

export const fileBox: SxProps = {
  width: '100%',
  background: grey10,
  borderRadius: '8px',
  display: 'flex',
  p: '12px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  mt: '28px',
};

export const leftSide: SxProps = { display: 'flex', alignItems: 'center', gap: '14px' };

export const leftSideFileInfo: SxProps = { display: 'flex', flexDirection: 'column', gap: '3px' };

export const fileSizeText: SxProps = {
  lineHeight: '1',
  fontSize: '12px',
  color: 'rgba(20, 25, 31, 0.60)',
};

export const deleteBtn: SxProps = {
  background: grey4,
  minWidth: '36px',
  height: '36px',
  width: '36px',
  p: '10px',
  '& .MuiSvgIcon-root': { width: '16px', height: '16px' },
  '&:hover': {
    background: grey4,
  },
};
